var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "6", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17014L13.0408 2.11014C12.4708 1.90014 11.5408 1.90014 10.9708 2.11014L5.47078 4.17014C4.41078 4.57014 3.55078 5.81014 3.55078 6.94014V15.0401C3.55078 15.8501 4.08078 16.9201 4.73078 17.4001L10.2308 21.5101C11.2008 22.2401 12.7908 22.2401 13.7608 21.5101L19.2608 17.4001C19.9108 16.9101 20.4408 15.8501 20.4408 15.0401V6.94014C20.4508 5.81014 19.5908 4.57014 18.5408 4.17014ZM12.0008 16.2501C9.38078 16.2501 7.25078 14.1201 7.25078 11.5001C7.25078 8.88014 9.38078 6.75014 12.0008 6.75014C14.6208 6.75014 16.7508 8.88014 16.7508 11.5001C16.7508 14.1201 14.6208 16.2501 12.0008 16.2501Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M16 12.999C15.448 12.999 15 12.551 15 11.999C15 11.447 15.448 10.999 16 10.999C16.552 10.999 17 11.447 17 11.999C17 12.551 16.552 12.999 16 12.999Z",
          fill: "white"
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M12 12.999C11.448 12.999 11 12.551 11 11.999C11 11.447 11.448 10.999 12 10.999C12.552 10.999 13 11.447 13 11.999C13 12.551 12.552 12.999 12 12.999Z",
          fill: "white"
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M8 12.999C7.448 12.999 7 12.551 7 11.999C7 11.447 7.448 10.999 8 10.999C8.552 10.999 9 11.447 9 11.999C9 12.551 8.552 12.999 8 12.999Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }